<template>
  <div class="pagemain">
    <menu2 style="z-index: 999" v-if="project_name" :page_name="'发薪申请记录-' + project_name" back_type="close"
      back_icon="md-close"></menu2>
    <!-- <div style="height: 40px"></div> -->

    <!-- <div class="head_box">
      <div class="head_left">
        <img class="logo_img" src="@/assets/image/auth/logo_white.png" alt="" />
        <span class="head_title">{{ project_name }} · 项目发薪申请记录</span>
      </div>
      <div class="head_right"></div>
    </div> -->
    <div style="height: 40px"></div>
    <div class="query_div">
      <div class="query_input">
        <div class="query_title">付款方式：</div>
        <Select clearable style="width: 120px" v-model="payment_type_id" placeholder="付款方式" size="small">
          <Option :disabled="item.disabled" v-for="item in payment_options" :value="item.value" :key="item.value">{{
            item.label }}</Option>
        </Select>
      </div>
      <div class="query_input">
        <div class="query_title">付款事由：</div>
        <Select clearable style="width: 120px" v-model="payment_cause_id" placeholder="付款事由类型..." size="small">
          <Option :disabled="item.disabled" v-for="item in cause_options" :value="item.value" :key="item.value">{{
            item.label }}</Option>
        </Select>
      </div>
      <div class="query_input">
        <div class="query_title">发放状态：</div>
        <Select clearable style="width: 100px" v-model="show_success" placeholder="筛选..." size="small">
          <Option v-for="item in query_audit_status_list" :value="item.value" :key="item.value">{{ item.label }}
          </Option>
        </Select>
      </div>
      <div class="query_input">
        <div class="query_title">备注：</div>
        <Input size="small" v-model="cause_remarks" style="width: 200px" placeholder="备注模糊搜索" />
      </div>
      <div>
        <Button @click="search" type="primary" size="small" style="font-size: 13px; margin-left: 10px">
          <Icon type="ios-search" />搜索
        </Button>
      </div>
    </div>
    <div class="faxin_txt">
      <!-- 发薪提交成功，员工可在公众号看到工资记录，显示（待发放），如想在工资发放成功后再让员工看到，可将开关关闭; -->
      <span>员工端显示待发放数据：
        <Switch v-model="pay_slip_switch_status" size="small" @on-change="pay_slip_switch_status_change" />
      </span>
      <span style="color:#989595">（默认显示待发放数据，如关闭后，发薪成功后员工才可看到工资信息）</span>

    </div>

    <div class="table_div">
      <Spin fix v-if="loading"></Spin>

      <Table :height="windowHeight - 130" :columns="columns" :data="audit_list" size="small" ref="table">
        <template #faxin_file="{ row }">
          <div>
            <span class="down_faxin" @click="down_faxin(row)" v-if="row.faxin_file">
              <Icon type="ios-cloud-download-outline" />发薪表
            </span>
            <span @click="click_faxin_table(row)" class="down_faxin2">
              <Icon type="ios-eye-outline" />查看发放数据
            </span>
          </div>
        </template>
        <template #fujian="{ row }">
          <div>
            <span class="down_faxin" @click="click_fujian(row)">
              <Icon type="ios-eye-outline" />查看附件
            </span>
          </div>
        </template>
        <template #action="{ row }">
          <div>
            <span v-if="row.is_audit == 0 && row.is_cancel == 0" class="revocation_span"
              @click="click_chexiao(row)">撤销</span>
          </div>
        </template>

        <template #audit_status_fmt="{ row }">
          <div>
            <Tag v-if="row.is_audit == 1" color="success">通过</Tag>
            <Tag v-if="row.is_audit == 2" color="error">不通过</Tag>
            <Tag v-if="row.is_audit == 0 && row.is_cancel == 0" color="warning">待审核</Tag>
            <Tag v-if="row.is_audit == 0 && row.is_cancel == 1" color="error">已撤销</Tag>
          </div>
        </template>
        <template #zhuguan_audit_fmt="{ row }">
          <div>
            <Tag v-if="row.zhuguan_audit_fmt == '通过'" color="success">通过</Tag>
            <Tag v-if="row.zhuguan_audit_fmt == '不通过'" color="error">不通过</Tag>
            <Tag v-if="row.zhuguan_audit_fmt == '待审核'" color="warning">待审核</Tag>
          </div>
        </template>
        <template #is_fafang="{ row }">
          <div>
            <Tag v-if="row.is_fafang == 0" color="warning">待发放</Tag>
            <Tag v-if="row.is_fafang == 1" color="success">已发放</Tag>
            <Tag v-if="row.is_fafang == 2" color="error">已撤销</Tag>
          </div>
        </template>
        <template #pay_slip="{ row }">
          <div v-if="row.pay_slip_upload_status" @click="upload_pay_slip(row)">
            <span class="pay_slip_span">
              <Icon type="ios-cloud-upload-outline" />工资条未上传
            </span>
          </div>
          <div v-else>
            <span class="pay_slip_span2" @click="view_pay_slip_detail(row)">
              <Icon type="ios-cloud-upload-outline" />已上传(查看)
            </span>
            <span class="down_psyslip_xls" @click="down_payslip(row)">下载</span>
          </div>
        </template>
        <template #audit_flow="{ row }">
          <div>
            <span class="flow_span" @click="click_flow(row)">
              <Icon type="ios-eye-outline" />审批流程
            </span>
          </div>
        </template>



      </Table>
    </div>
    <Drawer title="工资条详情" :closable="true" v-model="pay_slip_detail_show" width="80">
      <div class="upload_payslip_rer">
        <span class="chongxinshangchuan" @click="upload_pay_slip(this.view_pay_slip_item)">
          <Icon type="ios-cloud-upload-outline" />重新上传工资条数据
        </span>
        <span class="chongxinshangchuan_txt">提示：如重新上传会覆盖数据，工资条确认数据也会丢失</span>
      </div>
      <div>
        <div>
          <Table :height="windowHeight - 120" :columns="pay_slip_columns" :data="pay_slip_table_data" size="small">
            <template #confirm_time="{ row }">
              <span @click="view_confirm_img(row)" class="view_confirm_img">{{ row.confirm_time }}</span>
            </template>

          </Table>

        </div>

      </div>
    </Drawer>

    <Drawer title="附件列表" :closable="true" v-model="fujian_show" width="550">
      <div class="add_fujian_div">
        <Upload :show-upload-list="false" :action="upload_url_fujian" :on-success="upload_faxin_success" ref="upload01"
          :on-error="upload_error">
          <Button size="small" type="primary" style="font-size: 13px">
            <Icon type="md-add" />追加附件
          </Button>
        </Upload>
      </div>
      <!-- <div>
        <div class="fujian_title">图片附件列表</div>
        <Table
          height="200"
          :columns="fujian_colunms"
          :data="img_table"
          size="small"
          ref="table"
        >
          <template #url="{ row }">
            <div>
              <a :href="row.url" target="_black">下载文件</a>
            </div>
          </template>
        </Table>
      </div> -->
      <div>
        <!-- <div class="fujian_title">文件附件列表</div> -->
        <Table :height="windowHeight - 150" :columns="fujian_colunms" :data="file_table" size="small" ref="table">
          <template #url="{ row }">
            <div>
              <a :href="row.url" target="_black">下载文件</a>
            </div>
          </template>
        </Table>
      </div>
    </Drawer>

    <Drawer title="发薪列表" :closable="true" v-model="faxin_table_show" width="90">
      <div class="faxin_result_div">
        <span style="margin-right:20px;">共计{{ totalAgentCount }}条</span>
        <span style="margin-right:20px;color:green">发放成功{{ successAgentCount }}条</span>
        <span style="margin-right:10px;color:red">发放失败{{ totalAgentCount - successAgentCount }}条</span>

      </div>
      <div>
        <Spin fix v-if="loading2"></Spin>
        <Table :height="windowHeight - 120" :columns="columns2" :data="table_data2" size="small" ref="table">
          <template #fafang_status="{ row }">
            <Tag color="warning" v-if="row.fafang_status == '待发放'">待发放 </Tag>
            <Tag color="success" v-if="row.fafang_status == '发放成功'">发放成功 </Tag>
            <Tag color="error" v-if="row.fafang_status == '发放失败'">发放失败 </Tag>
          </template>
          <template #detail_status_fmt="{ row }">
            <div>
              <Tag color="success" v-if="row.detail_status == 'S'">{{ row.detail_status_fmt }}
              </Tag>

              <Tag color="error" v-if="row.detail_status == 'F' || row.detail_status == 'B'">{{ row.detail_status_fmt }}
              </Tag>

              <Tag color="warning" v-if="row.detail_status == 'W'">{{ row.detail_status_fmt }}
              </Tag>
            </div>
          </template>
          <template #recepit="{ row }">
            <div>
              <span class="receipt_span" @click="click_down_receipt(row)">下载回单</span>
            </div>
          </template>

          <template #month_jiesuan_status="{ row }">
            <div>
              <span class="jiesuan_status" @click="click_jiesuan_status(row)">
                <!-- {{ row.month_jiesuan_status }} -->
                {{ staff_yingfa_func(row) }}
              </span>
              <Icon type="ios-alert-outline" size="16" color="red" style="margin-left:3px"
                v-if="staff_jiesuan_status_func(row)" />
            </div>
          </template>
          <!-- <template #fafang_status="{ row }">
            <div>
              <Tag color="warning" v-if="['待发放','待处理'].indexOf(row.fafang_status) !=-1">{{ row.fafang_status }}
              </Tag>
          
              
              <Tag color="success" v-if="['发放成功','成功'].indexOf(row.fafang_status) !=-1">{{ row.fafang_status }}
              </Tag>
            
              <Tag color="error" v-if="['发放失败','失败','失败(有退款)'].indexOf(row.fafang_status) !=-1">{{ row.fafang_status }}
              </Tag>
              
            </div>
          </template> -->
        </Table>
      </div>
    </Drawer>

    <Drawer title="工资条数据上传" :closable="true" v-model="pay_slip_show" width="500px">
      <div class="down_pay_slip_template_div">
        <span @click="down_pay_slip_template" class="down_span">
          <Icon type="ios-cloud-download-outline" />&nbsp;&nbsp;点击下载工资条模板
        </span>
        &nbsp;
        &nbsp;
        <span class="down_span" @click="teaching_show=true">查看工资条上传教程</span>
        <span style="font-size: 13px;color:#000"><br>1.请下载最新模板，如更新一部分数据可仅传要修改的数据，则不会影响其他数据。<br>
          2.如果工资条字段不统一(例：部分字段不想给某部分人看)，可分多部分上传即可。<br><span>3.无发薪记录不可发工资条，请严格按模板提供的姓名填写</span> </span>
      </div>
      <div style="margin-top:10px">

        <Upload multiple type="drag" ref="upload3" :action="pay_slip_upload_url" :on-success="pay_slip_upload_success">
          <div style="padding: 20px 0">
            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
            <p>上传工资条更新模板</p>
          </div>
        </Upload>
      </div>
    </Drawer>

    <Modal v-model="pay_slip_view_show" title="工资条上传完成-结果预览" width="70">
      <div>
        <!-- <div class="yulan_txt">
          员工工资条结果-预览
        </div> -->
        <div class="pay_slip_view_div">
          <div v-for="(item, i) in pay_slip_resp_list" :key="i" class="pay_slip_view_div_resp">
            <div class="resp_name">
              姓名:{{ item.name }}
            </div>
            <div class="resp_name">
              身份证号：{{ item.idcard }}
            </div>
            <div style="height: 5px;"></div>
            <div v-for="(item2, i2) in item.kv_list" :key="i2" class="field_div">
              <div class="field_title">
                {{ item2.title }}
              </div>
              <div class="field_value">
                {{ item2.value }}
              </div>
            </div>
          </div>
        </div>

      </div>

    </Modal>

    <view_flow ref="view_flow"></view_flow>
    <Modal v-model="teaching_show" title="功能教学" :mask-closable="false" :footer-hide="true" :closable="true" width="1000"
      >
      <div class="teaching_modal">
        <iframe :src="tips_url" style="width:100%;height:calc(100% - 7px) " frameborder="0"></iframe>
      </div>

    </Modal>
  </div>
</template>

<script>
import { get_view_file_url, download_file, http, open_new_page } from "@/utils/http.js";
var Base64 = require("js-base64").Base64;
import menu2 from "@/component/menu/menu2.vue";
import view_flow from "@/component/flow/view_flow.vue";
import { Modal } from "view-ui-plus";
export default {
  components: {
    menu2,
    view_flow

  },
  data() {
    return {
      project_id: "",
      project_name: "",
      audit_list: [],
      columns: [],

      loading: false,

      faxin_table_show: false,
      table_data2: [],
      loading2: false,
      columns2: [],
      successAgentCount: 0,
      totalAgentCount: 0,

      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      fujian_show: false,
      img_table: [],
      file_table: [],
      fujian_colunms: [
        { title: "序号", type: "index", width: 60 },
        { title: "名称", key: "filename" },
        { title: "上传时间", width: 140, key: "create_time" },
        { title: "下载", key: "url", slot: "url", width: 100 },
      ],
      upload_url_fujian:
        process.env.VUE_APP_HOST +
        "/finance/payment/upload_accessory?type=file&token=" +
        this.$cookies.get("dx_token"),
      current_item: {},

      cause_options: [],
      payment_cause_id: "",

      // 付款方式
      payment_options: [],
      payment_type_id: '',

      // 付款原因
      cause_remarks: '',
      query_audit_status_list: [
        { 'label': '全部', value: 0 },
        { 'label': '只看通过', value: 1 },

      ],

      // 主管审核筛选
      show_success: 0,
      pay_slip_item: {},

      pay_slip_show: false,
      pay_slip_upload_url: '',
      pay_slip_resp_list: [],
      pay_slip_detail_show: false,
      view_pay_slip_item: {},

      pay_slip_columns: [],
      pay_slip_table_data: [],

      pay_slip_switch_status: true,
      pay_slip_view_show: false,
      unified_settlement_dict: {},

      teaching_show:false,
      tips_url:'https://doc.daxiangsys.com/share/345r1wyv60/p/-3qaB0fjTKb'


    };
  },
  mounted() {
    var query = this.$route.query;
    if (query) {
      this.project_id = query.project_id;
      this.project_name = query.project_name;
    }
    this.get_record();
    this.get_cause_options();
    this.get_payment_type()
  },

  methods: {
    pay_slip_switch_status_change(e) {
      var status = 0
      if (e) {
        status = 1
      }
      var that = this;
      var obj = {
        project_id: this.project_id,
        switch_status: status
      };
      http("post", process.env.VUE_APP_HOST + "/finance/payment/hide_daifafang", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_flow(row) {
      this.$refs.view_flow.open(row.flow_data)
    },

    down_faxin(row) {
      console.log(row);
      open_new_page(row.faxin_file);
    },

    click_fujian(row) {
      this.current_item = row;
      this.img_table = row.img_list;
      this.file_table = row.file_list;

      this.fujian_show = true;
    },

    click_faxin_table(row) {
      this.get_faxin(row.payment_id);
      this.faxin_table_show = true;
    },


    get_template_pay_slip() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        payment_id: this.pay_slip_item.payment_id,
      };
      http("post", process.env.VUE_APP_HOST + "/finance/payment/pay_slip_template", obj, true)
        .then((res) => {
          if (res.code == 0) {
            var object_name = res.data.object_name;
            var project_name = res.data.project_name
            var url = res.data.url
            download_file(url, project_name + '-工资条-更新模板')

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_faxin(payment_id) {
      var that = this;
      var obj = {
        project_id: this.project_id,
        payment_id: payment_id,
      };
      this.loading2 = true
      http("post", process.env.VUE_APP_HOST + "/finance/payment/faxin_table", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.columns2 = res.data.columns;
            that.table_data2 = res.data.table_data;
            that.successAgentCount = res.data.successAgentCount
            that.totalAgentCount = res.data.totalAgentCount
            that.unified_settlement_dict = res.data.unified_settlement_dict
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading2 = false
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_payment_type() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/finance/payment/payment_type", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.payment_options = res.data.options;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_record() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        payment_cause_id: this.payment_cause_id,
        payment_type_id: this.payment_type_id,
        cause_remarks: this.cause_remarks,
        show_success: this.show_success
      };
      this.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/payment_submit_record",
        obj,
        true
      )
        .then((res) => {
          console.log(res)
          if (res.code == 0) {
            that.columns = res.data.columns;
            that.audit_list = res.data.audit_list;
            that.project_name = res.data.project_name
            if (res.data.pay_slip_switch_status == 0) {
              that.pay_slip_switch_status = true
            } else {
              that.pay_slip_switch_status = false
            }

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_chexiao(row) {
      var that = this;
      this.$Modal.confirm({
        title: "撤销提示",
        content: "<p>正在撤销，撤销后无法返回，是否继续？</p>",
        onOk: () => {
          that.chexiao_request(row);
        },
        onCancel: () => { },
      });
    },

    chexiao_request(row) {
      var that = this;
      var obj = {
        payment_id: row.payment_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/faxin_revocation",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_record();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    upload_error(e) {
      this.$Message.error('上传失败')
    },
    // 添加新附件
    upload_faxin_success(e) {
      console.log(e);
      var object_name = e.data.object_name;

      this.append_file_request(object_name);
    },

    append_file_request(object_name) {
      var that = this;
      var obj = {
        payment_id: this.current_item.payment_id,
        file: object_name,
      };
      http("post", process.env.VUE_APP_HOST + "/finance/payment/append_file", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.fujian_show = false;
            that.get_record();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    search() {
      this.get_record();
    },

    get_cause_options() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/finance/payment/payment_cause", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.cause_options = res.data.options;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    down_pay_slip_template() {
      this.get_template_pay_slip()

    },

    pay_slip_upload_success(e) {
      console.log(e)
      if (e.code == 0) {
        this.$Message.success({ content: e.msg, duration: 5 })
        this.pay_slip_resp_list = e.data.resp_list
        this.pay_slip_view_show = true
      } else {
        this.$Message.error({ content: e.msg, duration: 5 })
        this.$refs.upload3.clearFiles()
      }
    },

    upload_pay_slip(row) {
      this.pay_slip_upload_url = ''
      this.pay_slip_upload_url = process.env.VUE_APP_HOST +
        "/finance/payment/upload_pay_slip_template?&token=" +
        this.$cookies.get("dx_token")
      this.pay_slip_upload_url += '&project_id=' + this.project_id
      this.pay_slip_upload_url += '&payment_id=' + row.payment_id

      this.pay_slip_item = row
      this.pay_slip_show = true
    },

    down_payslip(item) {
      get_view_file_url(item.pay_slip_file)
    },

    view_confirm_img(row) {
      if (row.sign_url == '') {
        this.$Message.error('没有签名图片')
        return
      }
      this.$ImagePreview.show({
        previewList: [row.sign_url]
      });
    },

    view_pay_slip_detail(row) {
      this.view_pay_slip_item = row
      this.pay_slip_detail_show = true
      this.get_pay_slip_table_data();
    },

    get_pay_slip_table_data() {
      var that = this;
      var obj = {
        payment_id: this.view_pay_slip_item.payment_id
      };
      http("post", process.env.VUE_APP_HOST + "/finance/payment/pay_slip_table_data", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.pay_slip_columns = res.data.columns
            that.pay_slip_table_data = res.data.table_data

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });

    },
    click_jiesuan_status(row) {
      var unified_settlement_dict = this.unified_settlement_dict
      let data = unified_settlement_dict[row.idcard];
      if (data) {
        let yingfa_money = data['yingfa_money']
        let yingfa_money_list = data['yingfa_money_list']

        const content = '<p>姓名:' + row.name + '，企业结算金额合计：￥' + yingfa_money + '</p><p>结算列表：' + yingfa_money_list + '</p>';
        this.$Modal.info({
          title: '当月结算详情',
          content: content
        });
      } else {
        this.$Message.info('该员工当月无结算数据')
      }
    },

    staff_yingfa_func(row) {
      var unified_settlement_dict = this.unified_settlement_dict
      let data = unified_settlement_dict[row.idcard];
      if (data) {
        let yingfa_money = data['yingfa_money']
        return yingfa_money
      } else {
        return '0'
      }

    },

    staff_jiesuan_status_func(row) {

      var unified_settlement_dict = this.unified_settlement_dict
      let data = unified_settlement_dict[row.idcard];
      if (data) {
        let yingfa_money = data['yingfa_money']
        let money = row.money
        if (parseFloat(money) > parseFloat(yingfa_money)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }
  },
};
</script>

<style scoped>
.teaching_modal {
  height: 70vh;
  background-color: #ccc;
}

.jiesuan_status:hover {
  font-weight: 600;
}

.jiesuan_status {
  color: #0466dd;
  cursor: pointer;
}


.faxin_txt {
  font-size: 13px;
  background-color: #edf6fc;
  border-radius: 3px;
  padding: 5px;
  margin: 8px 10px 0px 10px;
  display: flex;
  align-items: center;
}

.view_confirm_img {

  cursor: pointer;
  color: #0466dd
}

.chongxinshangchuan_txt {
  font-size: 13px;

  margin-left: 10px;
}

.upload_payslip_rer {
  padding: 0 5px 5px 5px;
}

.chongxinshangchuan {
  cursor: pointer;
  color: #0466dd
}

.down_psyslip_xls {
  cursor: pointer;
  color: #0466dd
}

.down_psyslip_xls:hover {
  font-weight: 600;
}

.pay_slip_view_div_resp {

  border: 1px solid #dbdbdb;
  box-shadow: 0 0 3px #dbdbdb;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.resp_div {
  width: 250px;
  border: 1px solid #dbdbdb;
  box-shadow: 0 0 3px #dbdbdb;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.resp_name {
  font-size: 13px;
  color: #888;
}

.yulan_txt {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.resp_div2 {
  height: calc(100vh - 320px);
  overflow: auto;
}


.pay_slip_view_div {
  overflow: auto;
  height: 500px;

}

.field_title {
  width: 150px;
  background-color: #f0f7ff;
  padding: 5px;
  font-size: 13px;
  color: #333;
  flex-shrink: 0;
}

.field_value {
  margin-left: 10px
}



.field_div {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  background-color: #f2f0f0;
}

.down_span {
  cursor: pointer;
  color: #2b00ff;

}

.down_span:hover {
  font-weight: 600;
}

.down_pay_slip_template_div {
  background-color: yellow;
  padding: 10px;
  border: 1px solid #ececec;
}

.pay_slip_span {
  cursor: pointer;
  color: #f90029;
}

.pay_slip_span:hover {
  font-weight: 600;
}

.pay_slip_span2:hover {
  font-weight: 600;
}

.pay_slip_span2 {
  cursor: pointer;
  color: #0466dd;
}

.faxin_result_div {
  height: 30px;
  font-size: 13px;
  display: flex;
  justify-content: center;
}

.flow_span {
  cursor: pointer;
  color: #0466dd;

}

.flow_span:hover {
  font-weight: 600;
}

.query_title {
  flex-shrink: 0;
}

.query_input {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.query_div {
  margin: 10px 10px 0 10px;
  display: flex;
  align-items: center;
}

.add_fujian_div {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.revocation_span {
  color: red;
  cursor: pointer;
}

.fujian_title {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin: 10px;
}

.pagemain {
  background: #ececec;
  min-height: 100vh;
}

.table_div {
  border-radius: 5px;
  margin: 10px;
  background: #fff;
}

.down_faxin {
  margin-right: 10px;
  color: #0466dd;
  cursor: pointer;
}

.down_faxin2 {
  cursor: pointer;
  color: #0466dd;
}

.down_faxin:hover {
  font-weight: 600;
}

.down_faxin2:hover {
  font-weight: 600;
}

.logo_img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.head_title {
  cursor: pointer;
  letter-spacing: 3px;
  font-size: 14px;
  font-weight: 400;
  color: rgb(255, 255, 255);
}

.head_left {
  display: flex;
  align-items: center;
}

.head_box {
  background: rgb(79, 135, 58);
  height: 40px;
  display: flex;
  z-index: 99;
  width: 100vw;
  position: fixed;
  top: 0;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0 20px;
}
</style>
